import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface StepperContainerProps {
  left?: number;
}

export default styled.div<StepperContainerProps>`
  width: 100%;
  display: flex;
  justify-content: center;

  @media screen and (min-width: ${DESKTOP}px) {
    position: absolute;
    top: 0;
    left: ${({ left = 40 }) => left}px;
    width: min-content;
    height: 100%;
    flex-direction: column;
  }
`;
